import React from "react";
import styled from "styled-components";
import {
  ID_TAB_TAKE_PRIZE,
  ID_TAB_MINI_GAME,
  useThadingyutTheme,
  useNewYear2025Theme,
  // IS_EVENT_THADINGYUT_2025_THEME
} from "../../../../helper/const";
import PATH from "../../../../config/PATH";
import { useNavigate } from "@hooks/useNavigate";
import { useTranslation } from "react-i18next";
import bgButtonActive from "../../../../assets/images/Mini-Game/bg-tab-popup-active-web.png";
import bgButtonActiveThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-tab-popup-active.png";
import bgButton from "../../../../assets/images/Mini-Game/bg-tab-popup-web.png";
import bgButtonActiveNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-piece-collection-btn.png";
import bgButtonNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize-btn.png";
import decoTango from "../../../../assets/images/Mini-Game/new-year-2025/tango-deco.png";
import decoSnowRight from "../../../../assets/images/Mini-Game/new-year-2025/snow-deco-right.png";
import decoSnowTop from "../../../../assets/images/Mini-Game/new-year-2025/btn-piece-collection-deco.png";
import decoStart from "../../../../assets/images/Mini-Game/new-year-2025/star-deco.png";

import iconTake from "../../../../assets/images/Event-2026/icon-take.png";
import iconPiece from "../../../../assets/images/Event-2026/icon-manhghep.png";

export default function Tab({ idActive = 1, itemProductActive }) {
  console.log('idActive: ', idActive)
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dataTab = [
    {
      id: ID_TAB_TAKE_PRIZE.takePrize,
      title: t("mini_game.take_prize.take_prize"),
      url: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}/${itemProductActive}`,
      icon: iconTake,
      class: 'tab_left'
    },
    {
      id: ID_TAB_TAKE_PRIZE.pieceCollection,
      title: t("mini_game.take_prize.piece_collection"),
      url: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}/${itemProductActive}`,
      icon: iconPiece,
      class: 'tab_right'
    },
  ];

  const handleClickPage = (url, id) => {
    if (idActive === id) {
      return null;
    }
    navigate(url);
  };

  return (
    <Container>
      <div className='mini-tab-popup'>
        {dataTab.map((item) => (
          <div
            key={item.id}
            className={`position-relative tab-mini-popup ${item.class} ${item.id === idActive ? "tab-popup-active" : ""
              }`}
            onClick={() => handleClickPage(item.url, item.id)}
          >
            {item.class === 'tab_right' ? (
              <>
                <div className='tab-popup__content'>{item.title}</div>
                <img src={item.icon} alt='' className='bg-tab-mini-web' />
              </>
            ) : (
              <>
                <img src={item.icon} alt='' className='bg-tab-mini-web' />
                <div className='tab-popup__content'>{item.title}</div>
              </>
            )}
          </div>
        ))}
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 20px;
  margin-left: 8px;
  margin-right: 8px;
  position: relative;
  z-index: 2;

  .mini-tab-popup {
    gap: 32px;
    position: relative;
    width: 100%;
    height: 55px;
    max-width: 825px;
    .deco {
      position: absolute;

      &.deco-bottom-right {
        bottom: 0;
        right: 0;
        transform: translate(10%, 32%);
        width: 80px;

        @media (max-width: 576px) {
          width: 48px;
          transform: translate(15%, 32%);
        }
      }

      &.deco-snow-right {
        width: 95px;

        @media (max-width: 576px) {
          width: 76px;
        }
      }

      &.deco-top {
        top: 0;
        right: 0;
        transform: translate(0%, -50%);
        width: 330px;

        &.deco-start {
          left: 0;
          top: 10%;
          width: 58px;
          height: 58px;

          @media (max-width: 576px) {
            top: 0;
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }

  .bg-tab-mini-web {
    max-height: 95px;

    &.new-year-25-theme {
      box-shadow: -5px 5px 20px 0px rgba(53, 18, 18, 0.5);
      border-radius: 99px;
    }
  }

  .tab-popup__content {
    font-size: 18px;
  }

  @media (min-width: 992px) {
    .tab-popup__mini-take:hover {
      opacity: 0.9;
      transition: 0.3s ease-in-out;
    }

  }
  
  @media (max-width: 992px) {
    .tab-popup__content {
      font-size: 18px;
    }
    .tab-mini-popup{
      height: 44px;
    }
  }

  @media (max-width: 542px) {
    .tab-popup__content {
      font-size: 16px;
    }
  }

  @media (max-width: 472px) {
    .tab-popup__content {
      font-size: 14px;
    }
    .mini-tab-popup {
      gap: 12px;
      height: 44px;
    }
  }

  @media (max-width: 425px) {
    .tab-popup__content {
      font-size: 14px;
    }
  }

  @media (max-width: 375px) {
    .tab-popup__content {
      font-size: 12px;
    }
  }
`;
